import SuperadminToolsContainer from './SuperadminToolsContainer';
export default SuperadminToolsContainer;
